var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-container" },
    [
      _c(
        "div",
        [
          _c(
            "sui-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "sui-grid",
                [
                  _c(
                    "sui-grid-row",
                    [
                      _c(
                        "sui-grid-column",
                        [
                          _c("sui-grid-column", [
                            _c("h2", { staticClass: "ui floated header" }, [
                              _vm._v("Cases"),
                            ]),
                          ]),
                          _c("sui-button", {
                            attrs: {
                              basic: "",
                              floated: "right",
                              size: "small",
                              content: "New",
                              color: "grey",
                            },
                            on: { click: _vm.handleNewTicket },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "sui-container",
            [
              _c("TicketListView", {
                attrs: { ticketList: _vm.tickets },
                on: { getTicket: _vm.getTicket },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("TicketModal", {
        attrs: {
          open: _vm.isOpen,
          isNew: _vm.isNew,
          ticket: _vm.ticket,
          toggleModal: _vm.toggleModal,
          modalHeaderText: _vm.modalHeaderText,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }